<template>
    <input
        v-show="false"
        ref="fileInput"
        type="file"
        :accept="props.accept"
        :multiple="props.multiple"
        @change="$emit('change', getEvent($event.target?.files))"
    />
    <button-base @click="fileInput.click()" :disabled="disabled">
        <slot>
            {{ $t('button.search') }}
        </slot>
    </button-base>
</template>

<script setup lang="ts">
import { ref } from "vue";

import ButtonBase from "@/components/button/ButtonBase.vue";

import { InputFileProps } from "@/types/props";

const props = defineProps<InputFileProps>()
defineEmits<{ (e: 'change', value: File | File[] | undefined): void }>()

const fileInput = ref();

const getEvent = (files: File[]): File | File[] | undefined => {
    if (!files) return;
    return props.multiple ? files : files[0]
}

</script>